import React, { Component } from 'react';
import { connect } from 'react-redux';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { NormalText, Spacer, StrongText, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import { forwardTo, isDefined } from '../../lib/utils';
import { QRCodeCanvas } from 'qrcode.react';
import { VoucherItem } from '../loyalty';
import { getConfig } from '../../appConfig';

class Voucher extends Component {
    componentDidMount() {
        if (!this.props.location?.state?.voucher) {
            forwardTo('/loyalty')
        }
    }
    render() {
        const { __, qr_code } = this.props;
        const voucher = this.props.location?.state?.voucher
        const voucherQRCode = voucher.additional_config?.qr_code ?? qr_code ?? null;
        return (
            <Loading>
                <Layout color="transparent" >
                    <div className='absolute-content scrollable-y'>
                        <Title>{__('Voucher details')}</Title>
                        <VoucherItem  {...voucher} __={__} />
                        <Spacer size={5} />

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            {voucherQRCode ? (

                                <div className='qr-code-wrapper' style={{ alignSelf: 'center' }}>

                                    <div className="qr-code">
                                        <div className={`${getConfig().flags.showVoucherID ? 'qr-holder-with-consumer-id' : ''}  qr-holder`}>
                                            <QRCodeCanvas value={voucherQRCode} size={160} />
                                            {getConfig().flags.showVoucherID && <StrongText style={{ width: '160px' }} className='block'>{voucherQRCode}</StrongText>}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <Spacer size={5} />
                        {voucher.reward?.description &&
                            <div className="voucher-modal-content">
                                <StrongText className="block text-to-update">{__('Voucher info')}</StrongText>
                                <Spacer size={2} />

                                <div></div>
                                <div className='voucher-description-modal'>
                                    <NormalText>
                                        {voucher.reward.description ? <div dangerouslySetInnerHTML={{ __html: voucher.reward.description }} /> : null}
                                    </NormalText>

                                </div>
                            </div>

                        }

                    </div>
                </Layout>
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    const { profile } = state.profile;


    return {
        profile,
        qr_code: state.profile.profile.qr_code,


    };
};

export default connect(stateToProps)(withTranslation(Voucher));
